import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        drivers: false
      },
      options: {
        drivers: []
      },
      selected: {
        driver: ''
      },
      editable: {
        driver: ''
      }
    }
  },

  methods: {

    async getDrivers (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.driver
      const fetching = context.fetching?.drivers
      const options = context.options?.drivers

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.drivers = true
      context.selected.driver = ''

      const filters = {
        filter_text: search
      }

      return await SSharedList.getDrivers(filters).then(
        ({ data }) => {
          context.options.drivers = data
        }
      ).catch(() => {
        context.options.drivers = []
      }).finally(() => {
        context.fetching.drivers = false
      })
    },

    async searchDrivers (search, loading) {
      this.searchDriversProvider(this, search, loading)
    },

    searchDriversProvider: QUERY.debounce(
      ({ options }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.drivers, {
          keys: ['driver_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search
          }

          SSharedList.getDrivers(filters).then(
            ({ data }) => {
              options.drivers = data
            }
          ).catch(() => {
            options.drivers = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
